import { authHeader } from "./auth-header";
import axiosInstance from "./axiosInstance";

const getAdminHeadersInfo = (date) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL +
      `transaction/admin/dashboard-header?date=${date}`,
    {
      headers: authHeader(),
    }
  );
};

const getAdminTransactionList = (param) => {
  return axiosInstance.Auth.get(
    process.env.REACT_APP_API_URL + "transaction/admin/list",
    {
      headers: authHeader(),
      params: param,
    }
  );
};

const getAdminTableInfo = (param) => {
  const url =
    param.paymentGateway === "all"
      ? `transaction/admin/dashboard-table?groupBy=${param.sortBy}&page=&perPage=`
      : `transaction/admin/dashborad-paydata?payBy=${param.paymentGateway}&groupBy=${param.sortBy}&page=&perPage=`;
  return axiosInstance.Auth.get(process.env.REACT_APP_API_URL + url, {
    headers: authHeader(),
    // params: param,
  });
};

export default {
  getAdminHeadersInfo,
  getAdminTransactionList,
  getAdminTableInfo,
};
